module.exports = __webpack_public_path__ + "static/media/truck-blur.fdc9be3c.jpg";